(() => {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire71f7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire71f7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lUrp0", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("71jDz")).then(()=>parcelRequire('5jecY'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("12XMR", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("1Qkna")).then(()=>parcelRequire('e5wvA'));

});

parcelRegister("6wFjG", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("8HIqJ")).then(()=>parcelRequire('9Was2'));

});

parcelRegister("jv8rb", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("aoEqc")).then(()=>parcelRequire('lHPpx'));

});

parcelRegister("cfZ4f", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("hxDi7")).then(()=>parcelRequire('bYIcb'));

});

parcelRegister("9nQT0", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("lQNZx")).then(()=>parcelRequire('2tZu7'));

});

parcelRegister("d9htE", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("aIh6s")).then(()=>parcelRequire('d9WzM'));

});

parcelRegister("157aC", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("3NDg4")).then(()=>parcelRequire('4cql8'));

});

var $722e3af074079bd2$exports = {};
$parcel$extendImportMap({
    "71jDz": "data_company.bf3413e7.js",
    "1Qkna": "navbar.f9139a1c.js",
    "8HIqJ": "search-input.84b02d06.js",
    "aoEqc": "slider.58b523bf.js",
    "hxDi7": "slider-category.da0da942.js",
    "lQNZx": "toolbar.3c77d002.js",
    "aIh6s": "video.357c4714.js",
    "3NDg4": "smartphone.1ab1a1f3.js"
});


const $a47582bbf5f95cea$var$data_company_selector = document.querySelector('.data_company');

if ($a47582bbf5f95cea$var$data_company_selector) {
    async function data_company() {
        return await (parcelRequire("lUrp0"));
    }
    data_company().then((r)=>{
        r.activeClassOnLabel($a47582bbf5f95cea$var$data_company_selector);
        r.openModal($a47582bbf5f95cea$var$data_company_selector);
        r.resetSecondaryFields($a47582bbf5f95cea$var$data_company_selector);
    }).catch((r)=>{
        console.log(r);
    });
}
const $a47582bbf5f95cea$var$navbar_selector = document.querySelector('.navbar');

if ($a47582bbf5f95cea$var$navbar_selector) {
    async function navbar() {
        return await (parcelRequire("12XMR"));
    }
    navbar().then((r)=>{
        r.toggleNavbarBurger($a47582bbf5f95cea$var$navbar_selector);
    }).catch((r)=>{
        console.log(r);
    });
}
const $a47582bbf5f95cea$var$search_selector = document.querySelectorAll('.search-input');

if ($a47582bbf5f95cea$var$search_selector.length > 0) {
    const search = async ()=>{
        return await (parcelRequire("6wFjG"));
    };
    $a47582bbf5f95cea$var$search_selector.forEach((item)=>{
        search().then((r)=>{
            r.searchResults(item);
        }).catch((r)=>{
            console.log(r);
        });
    });
}
const $a47582bbf5f95cea$var$slider_selector = document.querySelectorAll('.slider');

if ($a47582bbf5f95cea$var$slider_selector.length > 0) {
    const slider = async ()=>{
        return await (parcelRequire("jv8rb"));
    };
    $a47582bbf5f95cea$var$slider_selector.forEach((item)=>{
        slider().then((r)=>{
            r.initSlider(item);
        }).catch((r)=>{
            console.log(r);
        });
    });
}
const $a47582bbf5f95cea$var$sliderCategory_selector = document.querySelectorAll('.slider--category');

if ($a47582bbf5f95cea$var$sliderCategory_selector.length > 0) {
    const slider = async ()=>{
        return await (parcelRequire("cfZ4f"));
    };
    $a47582bbf5f95cea$var$sliderCategory_selector.forEach((item)=>{
        slider().then((r)=>{
            r.initSlider(item);
        }).catch((r)=>{
            console.log(r);
        });
    });
}
const $a47582bbf5f95cea$var$toolbar_selector = document.querySelector('.toolbar');

if ($a47582bbf5f95cea$var$toolbar_selector) {
    const toolbar = async ()=>{
        return await (parcelRequire("9nQT0"));
    };
    toolbar().then((r)=>{
        r.toggleToolbar($a47582bbf5f95cea$var$toolbar_selector);
        r.checkAllCategories($a47582bbf5f95cea$var$toolbar_selector);
    }).catch((r)=>{
        console.log(r);
    });
}
const $a47582bbf5f95cea$var$video_selector = document.querySelectorAll('.video');

if ($a47582bbf5f95cea$var$video_selector) {
    async function loadVideo() {
        return await (parcelRequire("d9htE"));
    }
    loadVideo().then((r)=>{
        $a47582bbf5f95cea$var$video_selector.forEach((item)=>{
            const video = new r.Video(item);
            video.load();
        });
    });
}
const $a47582bbf5f95cea$var$smartphone_selector = document.querySelector('#smartphone');

if ($a47582bbf5f95cea$var$smartphone_selector) {
    async function smartphone() {
        return await (parcelRequire("157aC"));
    }
    smartphone().then((r)=>{
        r.init($a47582bbf5f95cea$var$smartphone_selector);
    });
}

})();
//# sourceMappingURL=app.js.map
